import { render, staticRenderFns } from "./RequestsReceivedReport.vue?vue&type=template&id=005ad936&scoped=true&"
import script from "./RequestsReceivedReport.vue?vue&type=script&lang=js&"
export * from "./RequestsReceivedReport.vue?vue&type=script&lang=js&"
import style0 from "./RequestsReceivedReport.vue?vue&type=style&index=0&id=005ad936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005ad936",
  null
  
)

export default component.exports